/**
 * /semanadafisio — LP-catálogo da ação anual Semana da Fisioterapia.
 * URL sempre disponível (noindex); quando a ação está inativa a LP exibe
 * "oferta encerrada" e os cards de compra ficam desabilitados.
 */
import { createFileRoute } from "@tanstack/react-router";

import { SemanaFisioPage } from "@/components/lps/SemanaFisioPage";
import { getAcoesStateFn } from "@/lib/campanhas/acoes.functions";

export const Route = createFileRoute("/semanadafisio")({
  validateSearch: (search: Record<string, unknown>): { preview?: boolean } =>
    search.preview === "1" || search.preview === 1 || search.preview === true
      ? { preview: true }
      : {},
  head: () => ({
    meta: [
      { title: "Semana da Fisioterapia" },
      {
        name: "description",
        content:
          "Semana da Fisioterapia da FEO: pós-graduações, certificações, Star Cursos e Agente IA com até 80% de desconto. Ofertas renovadas todos os dias às 23h59.",
      },
      { property: "og:title", content: "Semana da Fisioterapia" },
      {
        property: "og:description",
        content: "Pós, certificações, Star Cursos e Agente IA com até 80% de desconto na maior ação do ano.",
      },
      { property: "og:url", content: "https://fisioemortopedia.com.br/semanadafisio" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Semana da Fisioterapia" },
      {
        name: "twitter:description",
        content: "Até 80% de desconto em pós, certificações, Star Cursos e Agente IA.",
      },
      { name: "robots", content: "noindex, follow" },
    ],
    links: [{ rel: "canonical", href: "https://fisioemortopedia.com.br/semanadafisio" }],
  }),
  loader: () => getAcoesStateFn(),
  component: SemanaFisioRoute,
});

function SemanaFisioRoute() {
  const acoes = Route.useLoaderData();
  const { preview } = Route.useSearch();
  // ?preview=1 → revisão interna da LP como se a ação estivesse ativa.
  const ativa = Boolean(acoes?.semanadafisio?.ativa) || preview === true;
  return <SemanaFisioPage ativa={ativa} />;
}
